// import React, { useState } from "react";

// function ProductShow(props) {

//     const [cantidad, setCantidad] = useState(
//         props.items.find((item) => item.product.id === props.product.id)?.quantity || 0
//     );

//     function updateCart(next) {
//         let cartCopy = [...props.cart];
//         let productIndex = cartCopy.findIndex((item) => item.product.id === props.product.id);

//         if (next === 0) {
//             if (productIndex !== -1) cartCopy.splice(productIndex, 1);
//         } else if (productIndex !== -1) {
//             cartCopy[productIndex].quantity = next;
//             cartCopy[productIndex].total = props.product.currentPrice * next;
//         } else {
//             cartCopy.push({
//                 product: props.product,
//                 quantity: next,
//                 total: props.product.currentPrice * next,
//             });
//         }

//         props.setCart(cartCopy);
//         props.setItems(cartCopy);
//     }

//     function handleSum(event) {
//         event.preventDefault();
//         if (cantidad < 20) {
//             const next = cantidad + 1;
//             setCantidad(next);
//             updateCart(next);
//         }
//     }

//     function handleRes(event) {
//         event.preventDefault();
//         if (cantidad > 0) {
//             const next = cantidad - 1;
//             setCantidad(next);
//             updateCart(next);
//         }
//     }

//     const isInCart = cantidad > 0;
//     const hasDiscount = props.product.originalPrice > props.product.currentPrice;
//     const discountPct = hasDiscount
//         ? Math.round((1 - props.product.currentPrice / props.product.originalPrice) * 100)
//         : 0;
//     const fmt = (n) => `$${Number(n).toLocaleString().replace(/,/g, ".")}`;

//     return (
//         <div
//             className={`
//                 relative flex flex-col bg-white overflow-hidden
//                 transition-all duration-200
//                 ${isInCart
//                     ? "rounded-2xl ring-2 ring-[#3a5c3e] shadow-lg shadow-[#1c2b1e]/10"
//                     : "rounded-2xl border border-gray-100 shadow-sm"
//                 }
//             `}
//             style={{ width: "168px", minWidth: "168px", height: "280px", overflow: "hidden" }}
//         >
//             {/* Badge cantidad en carrito */}
//             {isInCart && (
//                 <div className="absolute top-2 right-2 z-10 bg-[#1c2b1e] text-[#a8c5a0] text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shadow">
//                     {cantidad}
//                 </div>
//             )}

//             {/* Badge descuento — esquina superior izquierda */}
//             {hasDiscount && (
//                 <div className="absolute top-2 left-2 z-10 bg-red-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-md shadow">
//                     -{discountPct}%
//                 </div>
//             )}

//             {/* Imagen */}
//             <div
//                 className="w-full bg-white border-b border-gray-50 flex-shrink-0"
//                 style={{ height: "140px", overflow: "hidden" }}
//             >
//                 {props.product.imageUrl ? (
//                     <img
//                         src={props.product.imageUrl}
//                         alt={props.product.name}
//                         style={{
//                             width: "100%",
//                             height: "140px",
//                             objectFit: "contain",
//                             objectPosition: "center",
//                             display: "block",
//                         }}
//                     />
//                 ) : (
//                     <div className="w-full h-full flex items-center justify-center text-4xl">🌿</div>
//                 )}
//             </div>

//             {/* Info — solo texto, con padding lateral */}
//             <div className="px-3 pt-2 flex flex-col flex-1">
//                 <div>
//                     {/* Nombre */}
//                     <p className="text-[13px] font-semibold text-[#1a1f1a] leading-tight line-clamp-1">
//                         {props.product.name}
//                     </p>

//                     {/* Descripción */}
//                     <p className="text-[11px] text-gray-400 leading-tight line-clamp-1 mt-0.5">
//                         {props.product.description || "\u00a0"}
//                     </p>

//                     {/* Precio — espacio fijo reservado siempre para mantener altura uniforme */}
//                     <div style={{ minHeight: "38px" }} className="mt-1">
//                         {hasDiscount ? (
//                             <>
//                                 {/* Precio original tachado */}
//                                 <p className="text-[10px] text-gray-400 line-through leading-none">
//                                     {fmt(props.product.originalPrice)} / {props.product.type}
//                                 </p>
//                                 {/* Precio actual en oferta */}
//                                 <p className="text-[12px] text-red-500 font-bold leading-tight mt-0.5">
//                                     {fmt(props.product.currentPrice)} / {props.product.type}
//                                 </p>
//                             </>
//                         ) : (
//                             <>
//                                 {/* Placeholder invisible */}
//                                 <p className="text-[10px] leading-none invisible">&nbsp;</p>
//                                 {/* Precio normal */}
//                                 <p className="text-[11px] text-[#3a5c3e] font-semibold leading-tight mt-0.5">
//                                     {fmt(props.product.currentPrice)} / {props.product.type}
//                                 </p>
//                             </>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {/* Botón — fuera del padding, pegado al fondo, ancho completo */}
//             <div className="px-3 pb-3">
//                 {cantidad === 0 ? (
//                     <button
//                         onClick={handleSum}
//                         className="w-full py-2 rounded-xl bg-[#1c2b1e] text-[#f5f0e8] text-[12px] font-semibold active:scale-95 transition-transform"
//                     >
//                         Agregar
//                     </button>
//                 ) : (
//                     <div className="flex items-center justify-between bg-[#eef4ee] rounded-xl px-1 py-1">
//                         <button
//                             onClick={handleRes}
//                             className="w-8 h-8 rounded-lg bg-white text-[#1a1f1a] text-lg font-medium shadow-sm active:scale-90 transition-transform flex items-center justify-center"
//                         >
//                             −
//                         </button>
//                         <span className="text-[11px] font-semibold text-[#1a1f1a]">
//                             {cantidad} {cantidad === 1 ? props.product.subName : `${props.product.subName}s`}
//                         </span>
//                         <button
//                             onClick={handleSum}
//                             className="w-8 h-8 rounded-lg bg-[#1c2b1e] text-[#f5f0e8] text-lg font-medium shadow-sm active:scale-90 transition-transform flex items-center justify-center"
//                         >
//                             +
//                         </button>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default ProductShow;


import React, { useState } from "react";
import { trackAddToCart } from "../pixel";

function ProductShow(props) {

    const [cantidad, setCantidad] = useState(
        props.items.find((item) => item.product.id === props.product.id)?.quantity || 0
    );

    function updateCart(next) {
        let cartCopy = [...props.cart];
        let productIndex = cartCopy.findIndex((item) => item.product.id === props.product.id);

        if (next === 0) {
            if (productIndex !== -1) cartCopy.splice(productIndex, 1);
        } else if (productIndex !== -1) {
            cartCopy[productIndex].quantity = next;
            cartCopy[productIndex].total = props.product.currentPrice * next;
        } else {
            cartCopy.push({
                product: props.product,
                quantity: next,
                total: props.product.currentPrice * next,
            });
        }

        props.setCart(cartCopy);
        props.setItems(cartCopy);
    }

    function handleSum(event) {
        event.preventDefault();
        if (cantidad < 20) {
            const next = cantidad + 1;
            if (cantidad === 0) trackAddToCart(props.product);
            setCantidad(next);
            updateCart(next);
        }
    }

    function handleRes(event) {
        event.preventDefault();
        if (cantidad > 0) {
            const next = cantidad - 1;
            setCantidad(next);
            updateCart(next);
        }
    }

    const isInCart = cantidad > 0;
    const hasDiscount = props.product.originalPrice > props.product.currentPrice;
    const discountPct = hasDiscount
        ? Math.round((1 - props.product.currentPrice / props.product.originalPrice) * 100)
        : 0;
    const fmt = (n) => `$${Number(n).toLocaleString().replace(/,/g, ".")}`;

    // Huella usada como imagen de respaldo
    const PawFallback = () => (
        <div className="w-full h-full flex items-center justify-center bg-[#eef4f3]">
            <svg className="w-12 h-12 text-[#bcd4d2]" viewBox="0 0 64 64" fill="currentColor">
                <ellipse cx="20" cy="16" rx="7" ry="9" />
                <ellipse cx="44" cy="16" rx="7" ry="9" />
                <ellipse cx="9" cy="33" rx="6" ry="8" />
                <ellipse cx="55" cy="33" rx="6" ry="8" />
                <path d="M32 28c-9 0-17 7-17 16 0 7 5 11 12 11 3 0 4-1 5-1s2 1 5 1c7 0 12-4 12-11 0-9-8-16-17-16Z" />
            </svg>
        </div>
    );

    return (
        <div
            className={`
                relative flex flex-col bg-white overflow-hidden h-full w-full
                transition-all duration-200
                ${isInCart
                    ? "rounded-2xl ring-2 ring-[#f5853f] shadow-lg shadow-[#0f4a4e]/10"
                    : "rounded-2xl border border-gray-100 shadow-sm hover:shadow-md"
                }
            `}
        >
            {/* Badge cantidad en el carrito */}
            {isInCart && (
                <div className="absolute top-2 right-2 z-10 bg-[#0f4a4e] text-[#fdf7ef] text-[10px] font-bold rounded-full min-w-[20px] h-5 px-1 flex items-center justify-center shadow">
                    {cantidad}
                </div>
            )}

            {/* Badge descuento */}
            {hasDiscount && (
                <div className="absolute top-2 left-2 z-10 bg-[#f5853f] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-md shadow">
                    -{discountPct}%
                </div>
            )}

            {/* Imagen */}
            <div
                className="w-full bg-white border-b border-gray-50 flex-shrink-0"
                style={{ height: "140px", overflow: "hidden" }}
            >
                {props.product.imageUrl ? (
                    <img
                        src={props.product.imageUrl}
                        alt={props.product.name}
                        style={{
                            width: "100%",
                            height: "140px",
                            objectFit: "contain",
                            objectPosition: "center",
                            display: "block",
                        }}
                    />
                ) : (
                    <PawFallback />
                )}
            </div>

            {/* Info */}
            <div className="px-3 pt-2 flex flex-col flex-1">
                {/* Categoría (si el backend la entrega) */}
                {props.product.category && (
                    <span className="self-start text-[9px] font-semibold uppercase tracking-wide text-[#2a8a7d] bg-[#e3f0ef] px-1.5 py-0.5 rounded mb-1">
                        {props.product.category}
                    </span>
                )}

                {/* Nombre */}
                <p className="text-[13px] font-semibold text-[#1d2b2a] leading-tight line-clamp-2">
                    {props.product.name}
                </p>

                {/* Descripción */}
                <p className="text-[11px] text-gray-400 leading-tight line-clamp-1 mt-0.5">
                    {props.product.description || "\u00a0"}
                </p>

                {/* Precio — altura reservada para mantener tarjetas uniformes */}
                <div style={{ minHeight: "38px" }} className="mt-auto pt-1">
                    {hasDiscount ? (
                        <>
                            <p className="text-[10px] text-gray-400 line-through leading-none">
                                {fmt(props.product.originalPrice)} / {props.product.type}
                            </p>
                            <p className="text-[13px] text-[#f5853f] font-bold leading-tight mt-0.5">
                                {fmt(props.product.currentPrice)} / {props.product.type}
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="text-[10px] leading-none invisible">&nbsp;</p>
                            <p className="text-[12px] text-[#0f4a4e] font-bold leading-tight mt-0.5">
                                {fmt(props.product.currentPrice)} / {props.product.type}
                            </p>
                        </>
                    )}
                </div>
            </div>

            {/* Botón / contador */}
            <div className="px-3 pb-3">
                {cantidad === 0 ? (
                    <button
                        onClick={handleSum}
                        className="w-full py-2 rounded-xl bg-[#0f4a4e] text-[#fdf7ef] text-[12px] font-semibold active:scale-95 hover:bg-[#155e63] transition-all"
                    >
                        Agregar
                    </button>
                ) : (
                    <div className="flex items-center justify-between bg-[#e3f0ef] rounded-xl px-1 py-1">
                        <button
                            onClick={handleRes}
                            className="w-8 h-8 rounded-lg bg-white text-[#1d2b2a] text-lg font-medium shadow-sm active:scale-90 transition-transform flex items-center justify-center"
                        >
                            −
                        </button>
                        <span className="text-[11px] font-semibold text-[#1d2b2a] text-center px-1">
                            {cantidad} {cantidad === 1 ? props.product.subName : `${props.product.subName}s`}
                        </span>
                        <button
                            onClick={handleSum}
                            className="w-8 h-8 rounded-lg bg-[#0f4a4e] text-[#fdf7ef] text-lg font-medium shadow-sm active:scale-90 transition-transform flex items-center justify-center"
                        >
                            +
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProductShow;